export default {
    alerts: {
        index: {
            error: 'Échec lors de la recherche',
        },
    },
    lead: 'Leads',
    customer: 'Clients',
    fullName: 'Nom complet',
    note: 'Notes',
    recent: 'Leads Récents',
    recentSearch: 'Recherches récentes',
    recentViewed: 'Consulté récemment',
    results: 'Résultats',
    search: 'Recherche...',
    startTyping: 'Commencez à taper pour rechercher...',
    user: 'Utilisateurs',
    vehicle: 'Véhicules',
    viewAll: 'Voir tous les résultats',
    delete: 'Supprimer',
};
